import React, { useEffect, useRef, useState } from "react";
import {
  counterApi,
  dashboardFundCounterApi,
  transactionListApi,
  transactionListExportApi,
} from "../../../axios/services/services";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import ErrorModal from "../Modal/ErrorModal";
import { HistoryLoadingDialog } from "./history-loading-dialog/HistoryLoadingDialog";
import { HistoryCard } from "./HistoryCard";
import { HistoryUIProvider } from "./HistoryUIContext";
import SVG from "react-inlinesvg";
import { isUnauthorized } from "../../utils/utils";
import { initialFilter } from "./HistoryUIHelpers";
import { TransactionViewModal } from "./transaction-view-modal/TransactionViewModal";

export function HistoryPage({ history }) {
  const [isConfirmModal, setConfirmModal] = useState(false);
  const [data, setData] = useState({});
  const [transactionList, setTransactionList] = useState(null);
  const [counterList, setCounterList] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [loadingExportButton, setLoadingExportButton] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [transactionListTotalCount, setTransactionListTotalCount] = useState(0);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const [transactionListExport, setTransactionListExport] = useState([]);
  const [fundCounterList, setFundCounterList] = useState(null);
  const exportCSVButton = useRef();

  useEffect(() => {
    async function getTransactionList() {
      enableLoading();
      const transactionListResponse = await transactionListApi({
        filterValues,
        queryParams,
      });
      disableLoading();
      if (transactionListResponse.Error) {
        isUnauthorized({ response: transactionListResponse });
        setErrorMessage(transactionListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setTransactionListTotalCount(
        transactionListResponse && transactionListResponse.count
          ? transactionListResponse.count
          : 0
      );
      setTransactionList(
        transactionListResponse && transactionListResponse.data
          ? transactionListResponse.data
          : []
      );
    }
    getTransactionList();
  }, [filterValues, queryParams]);


  useEffect(() => {
    async function getCounterList() {
      const counterListResponse = await counterApi();
      if (counterListResponse.Error) {
        isUnauthorized({ response: counterListResponse });
        setErrorMessage(counterListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setCounterList(
        counterListResponse && counterListResponse ? counterListResponse : []
      );
    }
    getCounterList();
  }, []);

  useEffect(() => {
    async function getFundCounterList() {
      const fundCounterListResponse = await dashboardFundCounterApi();
      if (fundCounterListResponse.Error) {
        isUnauthorized({ response: fundCounterListResponse });
        setErrorMessage(fundCounterListResponse.Error.message);
        handleErrorModalShow();
        return;
      }

      setFundCounterList(
        fundCounterListResponse && fundCounterListResponse
          ? fundCounterListResponse
          : []
      );
    }
    getFundCounterList();
  }, []);

  const handleConfirmShow = () => {
    setConfirmModal(true);
  };

  const handleConfirmHide = () => {
    setConfirmModal(false);
  };

  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };
  const handleFilterValues = (values) => {
    setFilterValues(values);
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const enableLoadingExportButton = () => {
    setLoadingExportButton(true);
  };

  const disableLoadingExportButton = () => {
    setLoadingExportButton(false);
  };

  const handleSetCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const historyUIEvents = {
    openReceiptDialog: (row) => {
      setData(row);
      handleConfirmShow();
    },
  };

  const handleExportButton = async () => {
    enableLoadingExportButton();
    const transactionListExportResponse = await transactionListExportApi({
      limit: transactionListTotalCount,
    });
    disableLoadingExportButton();
    if (transactionListExportResponse.Error) {
      isUnauthorized({ response: transactionListExportResponse });
      setErrorMessage(transactionListExportResponse.Error.message);
      handleErrorModalShow();
      return;
    } else {
      setTransactionListExport(transactionListExportResponse.data);
      exportCSVButton.current.link.click();
    }
  };

  return (
    <>
      <HistoryUIProvider
        historyUIEvents={historyUIEvents}
        queryParams={queryParams}
        setQueryParamsBase={setQueryParamsBase}
        ids={ids}
        setIds={setIds}
      >
        <HistoryLoadingDialog />
        {isConfirmModal && (
          <TransactionViewModal
            data={data}
            handleConfirmHide={handleConfirmHide}
            isConfirmModal={isConfirmModal}
          />
        )}

        <HistoryCard
          isLoading={isLoading}
          counterList={counterList}
          fundCounterList={fundCounterList}
          transactionList={transactionList}
          handleFilterValues={handleFilterValues}
          filterValues={filterValues}
          loadingExportButton={loadingExportButton}
          transactionListExport={transactionListExport}
          handleExportButton={handleExportButton}
          exportCSVButton={exportCSVButton}
          transactionListTotalCount={transactionListTotalCount}
          currentPage={currentPage}
          setCurrentPage={handleSetCurrentPage}
        />
      </HistoryUIProvider>

      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
    </>
  );
}
